<template>
  <v-btn
    :prepend-icon="`fas ${icon}`"
    :text="name"
    color="primary"
    size="small"
    @click="sharePage"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useErrorStore } from '@/stores/errors';

const props = withDefaults(defineProps<{
  model: Record<string, any>;
  name?: string;
  field?: string;
  icon?: string;
}>(), {
  field: () => 'signed_page_url',
  icon: () => 'fa-share',
});
const emit = defineEmits(['click', 'reload']);
const { t } = useI18n();
const { handleError } = useErrorStore();
async function sharePage() {
  emit('click');
  try {
    await navigator.share({
      title: props.name || t('url.share_x', { x: document.title }),
      url: props.model[props.field],
    });
  }
  catch (err) {
    // Dismissing the share sheet rejects with an AbortError, which is not a
    // failure worth reporting. Anything without a name is still reported, as
    // it was before.
    const name = err instanceof Error
      ? err.name
      : undefined;
    if (name !== 'AbortError') {
      handleError(err, t('url.page_share_failed'));
    }
  }
}
</script>
